import { useState } from 'react';
import { Link } from "react-router-dom";
import { ArrowLeftIcon, EnvelopeIcon } from "@heroicons/react/24/solid";
import { postRequest } from "../../Requests/postRequests";
import { useDispatch } from "react-redux";
import { show } from '../../slices/toastSlice';
import Logo from "../../assets/images/logo.png";

// Staff forgot password: asks for the email and the server emails a one-time
// reset link (handled by ResetPassword). The answer is the same whether or not
// the email has an account.
function ForgotPassword() {

    const dispatch = useDispatch();

    const [email, setEmail] = useState("");
    const [sentMessage, setSentMessage] = useState("");
    const [process, setProcess] = useState(false);

    const handleRequest = async (e) => {
        e.preventDefault();
        setProcess(true);

        const res = await postRequest(`/auth/staff/forgot_password`, { email });

        setProcess(false);

        if (!res || res?.err) {
            dispatch(show({ type: "error", state: true, message: res?.err || "Something went wrong. Please try again." }));
            return;
        }

        setSentMessage(res.message || "If that email belongs to a staff account, a reset link has been sent");
    };

    return (
        <div className="min-h-screen bg-slate-50 dark:bg-gray-950 flex items-center justify-center p-4">
            <div className="w-full max-w-sm">

                {/* Logo */}
                <div className="flex justify-center mb-8">
                    <img src={Logo} alt="CedisPay" className="h-10 w-auto object-contain" />
                </div>

                {/* Card */}
                <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 shadow-sm p-8">

                    {sentMessage ? (
                        <>
                            <div className="flex justify-center mb-5">
                                <EnvelopeIcon className="w-10 h-10 text-light-blue" />
                            </div>
                            <h1 className="text-2xl font-semibold tracking-tight text-gray-900 dark:text-white text-center">
                                Check your email
                            </h1>
                            <p className="mt-2 text-sm text-gray-500 dark:text-gray-400 text-center">
                                {sentMessage.replace(/\.$/, "")}. The link expires in 30 minutes and can only be used once.
                            </p>
                            <button
                                type="button"
                                onClick={() => setSentMessage("")}
                                className="mt-6 w-full text-sm font-medium text-blue-600 dark:text-blue-400 hover:underline"
                            >
                                Use a different email
                            </button>
                        </>
                    ) : (
                        <>
                            <div className="mb-7">
                                <h1 className="text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">
                                    Reset password
                                </h1>
                                <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                                    Enter your email and we'll send you a link to reset your password
                                </p>
                            </div>

                            <form onSubmit={handleRequest} className="space-y-5">
                                <div>
                                    <label htmlFor="email" className="form-label">Email address</label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        autoComplete="email"
                                        required
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="form-input"
                                        placeholder="you@cedispay.com"
                                    />
                                </div>

                                <button
                                    type="submit"
                                    disabled={process}
                                    className="w-full h-11 flex items-center justify-center rounded-xl bg-light-blue hover:bg-dark-blue text-white text-sm font-semibold transition-colors disabled:opacity-60 disabled:cursor-not-allowed mt-2"
                                >
                                    {process ? (
                                        <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                                        </svg>
                                    ) : (
                                        "Send reset link"
                                    )}
                                </button>
                            </form>
                        </>
                    )}

                </div>

                {/* Footer */}
                <p className="mt-5 text-center">
                    <Link
                        to="/login"
                        className="inline-flex items-center gap-1.5 text-sm text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition-colors"
                    >
                        <ArrowLeftIcon className="w-3.5 h-3.5" />
                        Back to sign in
                    </Link>
                </p>

            </div>
        </div>
    );
}

export default ForgotPassword;
